import React, { useContext, useState, useEffect } from 'react'
import PropTypes, { func } from 'prop-types'
import classNames from 'classnames'

import { I18nContext } from '../../I18n'
import styles from './Message.module.css'

const StorageKey = 'cookieAccept';

Message.propTypes = {
  start: PropTypes.number
}

export default function Message({ start }) {
  const I18n = useContext(I18nContext);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => { 
    const CookieConstant = sessionStorage.getItem(StorageKey);
    if (CookieConstant === 'true') {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem(StorageKey, 'true');
    setIsVisible(false);
  }
  
  if (!isVisible) {
    return null;
  }

  return (

    <div className={classNames(styles.cookienotice, styles.visible)} id="cookieNotice">
        <div className={styles.cookiecontainer}>
            <div className={styles.cookietext}>
                <div className={styles.cookietitle}>{I18n.t('pages.index.message.title')}</div>
                    {I18n.t('pages.index.message.text')}
            </div>
            <div className={styles.cookiebuttons}>
                <a href='https://lunn.ru/media/sveden/doc/2025/politika_po_rabote_s_faymali_kukis_2025.pdf' className={classNames(styles.cookiebutton, styles.cookiebuttondetails)} id="moreButton">
                    {I18n.t('pages.index.message.button1')}
                </a>
                 <button onClick={handleAccept} className={classNames(styles.cookiebutton, styles.cookiebuttonaccept)} id="acceptButton">
                    {I18n.t('pages.index.message.button2')}
                </button>
            </div>
        </div>
    </div>
  )

  
}
